import React from "react";

const MetricCard = ({
  label,
  period,
  mainValue,
  accentColor,
  labelColor,
  rows = [],
  style = {},
  onClick,
}) => {
  return (
    <div
      className={`analytics-metric-card${onClick ? " analytics-metric-card--clickable" : ""}`}
      style={style}
      onClick={onClick}
    >
      <div className="metric-card-header">
        <span
          className="metric-card-label"
          style={{ color: labelColor || accentColor }}
        >
          {label}
        </span>
        <span className="metric-card-period">{period}</span>
      </div>
      <div className="metric-card-value" style={{ color: accentColor }}>
        {mainValue}
      </div>
      {rows.length > 0 && (
        <div className="metric-card-table">
          {rows.map((row, i) => (
            <div key={i} className="metric-card-row">
              <span className="metric-card-row-label">{row.label}</span>
              <span className="metric-card-row-value">{row.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MetricCard;
